import React from 'react';

import { Pagination as AntPagination } from 'antd';

/**
 * @typedef {Object} IPagination
 * @property {string} [className]
 * @property {number} [defaultPage]
 * @property {number} [currentPage]
 * @property {number} totalRows
 * @property {number} [pageSize]
 * @property {(page: number, pageSize: number) => void } [onPageChange]
 */

/**
 * @description UI component for pagination
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @reference https://ant.design/components/pagination
 *
 * @param {IPagination} props
 *
 * @returns {React.Element}
 */

const Pagination = ({
	className,
	defaultPage = 1,
	currentPage = 1,
	totalRows = -1,
	pageSize = 10,
	onPageChange,
}) => {
	return (
		<AntPagination
			className={className}
			showSizeChanger={false}
			defaultCurrent={defaultPage}
			current={currentPage}
			total={totalRows}
			pageSize={pageSize}
			onChange={onPageChange}
		/>
	);
};

Pagination.displayName = 'Pagination';

export default Pagination;
